import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
import { jsS, extend } from "@pnp/common";
/**
 * Describes a collection of Drive objects
 *
 */
var Drives = /** @class */ (function (_super) {
    tslib_1.__extends(Drives, _super);
    function Drives() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a Drive instance by id
     *
     * @param id Drive id
     */
    Drives.prototype.getById = function (id) {
        return new Drive(this, id);
    };
    Drives = tslib_1.__decorate([
        defaultPath("drives")
    ], Drives);
    return Drives;
}(GraphQueryableCollection));
export { Drives };
/**
 * Describes a Drive instance
 *
 */
var Drive = /** @class */ (function (_super) {
    tslib_1.__extends(Drive, _super);
    function Drive() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Drive.prototype, "root", {
        get: function () {
            return new Root(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Drive.prototype, "items", {
        get: function () {
            return new DriveItems(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Drive.prototype, "list", {
        get: function () {
            return new DriveList(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Drive.prototype, "recent", {
        get: function () {
            return new Recent(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Drive.prototype, "sharedWithMe", {
        get: function () {
            return new SharedWithMe(this);
        },
        enumerable: true,
        configurable: true
    });
    Drive = tslib_1.__decorate([
        defaultPath("drive")
    ], Drive);
    return Drive;
}(GraphQueryableInstance));
export { Drive };
/**
 * Describes a Root instance
 *
 */
var Root = /** @class */ (function (_super) {
    tslib_1.__extends(Root, _super);
    function Root() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Root.prototype, "children", {
        get: function () {
            return new Children(this);
        },
        enumerable: true,
        configurable: true
    });
    Root.prototype.search = function (query) {
        return new DriveSearch(this, "search(q='" + query + "')");
    };
    Root = tslib_1.__decorate([
        defaultPath("root")
    ], Root);
    return Root;
}(GraphQueryableInstance));
export { Root };
/**
 * Describes a collection of Drive Item objects
 *
 */
var DriveItems = /** @class */ (function (_super) {
    tslib_1.__extends(DriveItems, _super);
    function DriveItems() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a Drive Item instance by id
     *
     * @param id Drive Item id
     */
    DriveItems.prototype.getById = function (id) {
        return new DriveItem(this, id);
    };
    DriveItems = tslib_1.__decorate([
        defaultPath("items")
    ], DriveItems);
    return DriveItems;
}(GraphQueryableCollection));
export { DriveItems };
/**
 * Describes a Drive Item instance
 *
 */
var DriveItem = /** @class */ (function (_super) {
    tslib_1.__extends(DriveItem, _super);
    function DriveItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DriveItem.prototype, "children", {
        get: function () {
            return new Children(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DriveItem.prototype, "thumbnails", {
        get: function () {
            return new Thumbnails(this);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Deletes this Drive Item
     */
    DriveItem.prototype.delete = function () {
        return this.deleteCore();
    };
    /**
     * Update the properties of a Drive item
     *
     * @param properties Set of properties of this Drive Item to update
     */
    DriveItem.prototype.update = function (properties) {
        return this.patchCore({
            body: jsS(properties),
        });
    };
    /**
     * Move the Drive item and optionally update the properties
     *
     * @param parentReference Should contain Id of new parent folder
     * @param properties Optional set of properties of this Drive Item to update
     */
    DriveItem.prototype.move = function (parentReference, properties) {
        var patchBody = extend({}, parentReference);
        if (properties) {
            patchBody = extend({}, properties);
        }
        return this.patchCore({
            body: jsS(patchBody),
        });
    };
    return DriveItem;
}(GraphQueryableInstance));
export { DriveItem };
/**
 * Return a collection of DriveItems in the children relationship of a DriveItem
 *
 */
var Children = /** @class */ (function (_super) {
    tslib_1.__extends(Children, _super);
    function Children() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
    * Create a new folder or DriveItem in a Drive with a specified parent item or path
    * Currently only Folder or File works
    * @param name The name of the Drive Item.
    * @param properties Type of Drive Item to create.
    * */
    Children.prototype.add = function (name, driveItemType) {
        var _this = this;
        var postBody = extend({
            name: name,
        }, driveItemType);
        return this.postCore({
            body: jsS(postBody),
        }).then(function (r) {
            return {
                data: r,
                driveItem: new DriveItem(_this, r.id),
            };
        });
    };
    Children = tslib_1.__decorate([
        defaultPath("children")
    ], Children);
    return Children;
}(GraphQueryableCollection));
export { Children };
var DriveList = /** @class */ (function (_super) {
    tslib_1.__extends(DriveList, _super);
    function DriveList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DriveList = tslib_1.__decorate([
        defaultPath("list")
    ], DriveList);
    return DriveList;
}(GraphQueryableCollection));
export { DriveList };
var Recent = /** @class */ (function (_super) {
    tslib_1.__extends(Recent, _super);
    function Recent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Recent = tslib_1.__decorate([
        defaultPath("recent")
    ], Recent);
    return Recent;
}(GraphQueryableInstance));
export { Recent };
var SharedWithMe = /** @class */ (function (_super) {
    tslib_1.__extends(SharedWithMe, _super);
    function SharedWithMe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SharedWithMe = tslib_1.__decorate([
        defaultPath("sharedWithMe")
    ], SharedWithMe);
    return SharedWithMe;
}(GraphQueryableInstance));
export { SharedWithMe };
var DriveSearch = /** @class */ (function (_super) {
    tslib_1.__extends(DriveSearch, _super);
    function DriveSearch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DriveSearch = tslib_1.__decorate([
        defaultPath("search")
    ], DriveSearch);
    return DriveSearch;
}(GraphQueryableInstance));
export { DriveSearch };
var Thumbnails = /** @class */ (function (_super) {
    tslib_1.__extends(Thumbnails, _super);
    function Thumbnails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Thumbnails = tslib_1.__decorate([
        defaultPath("thumbnails")
    ], Thumbnails);
    return Thumbnails;
}(GraphQueryableInstance));
export { Thumbnails };
//# sourceMappingURL=onedrive.js.map